import i18n from '../../i18n'

const RETAKE_OPTIONS = [null, 3, 1]

export const retakeOptions = () => RETAKE_OPTIONS.map(value => ({
  value,
  label: value ? i18n.t('certificationBuilder.quiz.retakesAttempts', { count: value }) : i18n.t('certificationBuilder.quiz.retakesUnlimited'),
}))

export const lessonOrderOptions = () => [
  { value: true, label: i18n.t('certificationBuilder.details.sequential') },
  { value: false, label: i18n.t('certificationBuilder.details.free') },
]

export const findOption = (options, value) => options.find(option => option.value === value) || { value, label: String(value) }
